// extracted by mini-css-extract-plugin
module.exports = {"submitResultNotification":"j8_j9","overflowText":"j8_ka"};